import { render, staticRenderFns } from "./veJkyUser.vue?vue&type=template&id=3671f57c&scoped=true"
import script from "./veJkyUser.vue?vue&type=script&lang=js"
export * from "./veJkyUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3671f57c",
  null
  
)

export default component.exports